/* eslint-disable no-console */
import { useAuthStore } from "@/store/auth";
import { crowdfundingUrl, investeUrl } from "~/utils/constants";

const OPPORTUNITIES_DETAIL_DIRECT_QUERY = `
query OpportunitiesDetailDirect($operationId: String!, $crowdfunding: Boolean) {
  operation(crowdfunding: $crowdfunding, operationId: $operationId) {
    items {
      id
      url
    }
  }
}
`;

const getOpportunitiesDetail = async ({
  operationId,
  crowdfunding,
}: {
  operationId: string;
  crowdfunding: boolean;
}) => {
  const env = useRuntimeConfig();

  try {
    const res = await fetch(env.public.graphqlBaseURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: OPPORTUNITIES_DETAIL_DIRECT_QUERY,
        variables: { operationId, crowdfunding },
      }),
    });
    return res.json().then((res) => res?.data);
  } catch (error) {
    return null;
  }
};

const isPathOpportunityDetailPanel = (path: string) => {
  return /^\/painel\/oportunidades\/[^/]+$/.test(path);
};

export const useSignOut = () => {
  const auth = useAuthStore();
  const router = useRouter();
  const nuxtApp = useNuxtApp();

  return async () => {
    const route = router.currentRoute.value;

    if (route.path.startsWith("/basket/")) {
      return navigateTo({
        path: "/login",
        query: {
          redirectTo: route.path,
        },
      });
    }

    const mustRedirectToLanding =
      route.fullPath.startsWith("/painel") ||
      route.fullPath.startsWith("/completar-cadastro") ||
      route.meta.auth;

    const mustRedirectToFdiAuth =
      route.name === "FdiValue" ||
      route.name === "FdiConfirmation" ||
      route.name === "FdiEquity";

    auth.signOut();

    console.log("useSignOut called");
    console.log("Current route:", route);
    console.log("mustRedirectToLanding:", mustRedirectToLanding);
    console.log("mustRedirectToFdiAuth:", mustRedirectToFdiAuth);
    console.log("Route name:", route.name);
    console.log("Route path:", route.path);
    console.log(
      "isPathOpportunityDetailPanel:",
      isPathOpportunityDetailPanel(route.path),
    );

    if (route.name === "OpportunitiesPanelCr") {
      return navigateTo(`${crowdfundingUrl}/oportunidades`, {
        external: true,
      });
    }

    if (route.name === "OpportunitiesPanelNotCr") {
      return navigateTo(`${investeUrl}/oportunidades`, {
        external: true,
      });
    }

    if (
      route.name === "OpportunityDetailPanel" ||
      isPathOpportunityDetailPanel(route.path)
    ) {
      const [responseCr, responseNonCr] = await Promise.all([
        getOpportunitiesDetail({
          operationId: route.params.operationId as string,
          crowdfunding: true,
        }),
        getOpportunitiesDetail({
          operationId: route.params.operationId as string,
          crowdfunding: false,
        }),
      ]);

      return nuxtApp.runWithContext(() => {
        const isCr = responseCr?.operation?.items?.length;
        const isNonCr = responseNonCr?.operation?.items?.length;

        if (isCr) {
          const operation = responseCr?.operation?.items[0];
          const slug = operation?.url;

          return navigateTo(
            `${crowdfundingUrl}/oportunidades/${slug || route.params.operationId}`,
            {
              external: true,
            },
          );
        } else if (isNonCr) {
          const operation = responseNonCr?.operation?.items[0];
          const slug = operation?.url;

          return navigateTo(
            `${investeUrl}/oportunidades/${slug || route.params.operationId}`,
            {
              external: true,
            },
          );
        }
      });
    }

    if (mustRedirectToFdiAuth) {
      return navigateTo({
        name: "FdiAuth",
        params: { operationId: route.params.operationId },
      });
    } else if (mustRedirectToLanding) {
      return navigateTo("/");
    }
  };
};
